import { TChannelsChoice } from '../templates/channelsChoice';

export const ChannelsChoice = () => {
  return <TChannelsChoice></TChannelsChoice>;
};
